var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRainbow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rainbow_svg__clip0_2637_47780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 31c0 4.666-1.278 9.032-3.503 12.77-.293.492-.657-2.825-.982-2.355a24.968 24.968 0 01-3.36 3.918 24.859 24.859 0 01-2.305 1.94c-.637.476-1.3.921-1.982 1.333-.722.438-1.415 4.638-2.183 5.001a24.83 24.83 0 01-7.859 2.235c-.927.104-1.87-8.275-2.826-8.275-12.181 0-16.684-3.442-24.549-11.814A25.128 25.128 0 013 31C3 17.193 14.193 6 28 6s25 11.193 25 25z",
    fill: "#E7CD6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.11 27.422l9.013-.221s.284-1.95.618-4.799c-2.897.32-5.821.544-8.755.667-.554 2.606-.877 4.353-.877 4.353z",
    fill: "#FF696A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.101.316c-.806-.062-1.668 1.082-2.525 2.922 1.353.093 2.703.176 4.052.252C36.387 1.6 35.917.38 35.1.316z",
    fill: "#D379FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.625 3.493a225.72 225.72 0 01-4.053-.253c-.59 1.263-1.175 2.86-1.739 4.624 1.999-.11 3.995-.217 5.997-.325.003-1.521-.06-2.906-.205-4.046z",
    fill: "#79D5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.832 7.54c-1.999.11-3.995.217-5.997.325-.471 1.469-.93 3.055-1.364 4.669 2.394-.039 4.79-.061 7.186-.078a81.39 81.39 0 00.175-4.916z",
    fill: "#96FD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.044 18.275a268.276 268.276 0 00-1.064 4.795c2.94-.123 5.858-.347 8.756-.666.18-1.527.373-3.309.547-5.19-2.766.25-5.517.606-8.24 1.061z",
    fill: "#FF9F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.289 17.213c.146-1.549.273-3.162.37-4.752-2.395.014-4.797.037-7.187.078-.516 1.93-.997 3.896-1.427 5.742 2.721-.461 5.472-.817 8.244-1.068z",
    fill: "#FFB531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.546 24.177a3.843 3.843 0 100-7.686 3.843 3.843 0 000 7.686z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.032 22.576a2.242 2.242 0 100-4.483 2.242 2.242 0 000 4.483z",
    fill: "#453D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.393 20.187a1.119 1.119 0 100-2.238 1.119 1.119 0 000 2.238z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.182 10.907a3.702 3.702 0 00-3.702 3.702v4.481h7.404V14.61a3.702 3.702 0 00-3.702-3.702z",
    fill: "#69C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.287 11.074a3.706 3.706 0 00-2.599 3.535v4.481H22.48V14.61a3.702 3.702 0 014.807-3.535z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.322 11.654a5.182 5.182 0 010 10.364V11.654z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.023 24.026H24.04a7.14 7.14 0 01-6.27 7.645 7.142 7.142 0 01-4.777 8.275 8.276 8.276 0 01.939 3.837c0 2.328 1.723 1.782.183 3.291-.843-.746-1.55-.556-2.286-1.409-.5-.581-3.741.472-4.189-.154a24.862 24.862 0 01-4.188-9.758 7.4 7.4 0 01.626-.144 7.14 7.14 0 015.86-9.542 7.14 7.14 0 016.984-8.625h8.993a3.108 3.108 0 013.108 3.108v3.476z",
    fill: "#69C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 24.582c0 .51.056 1.006.157 1.485a7.14 7.14 0 00-5.86 9.542 8.312 8.312 0 00-4.897 2.903 24.467 24.467 0 01-.698-2.759c.205-.057.414-.104.626-.144a7.14 7.14 0 015.86-9.542 7.14 7.14 0 016.984-8.625h4.97a7.14 7.14 0 00-7.141 7.14z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.55 21H20.193v9.811a9.056 9.056 0 0016.217 5.54h.39c.452 3.146 3.163 5.572 6.432 5.572 3.584 0 6.5-2.916 6.5-6.5V24.18A3.18 3.18 0 0046.55 21z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.634 35.69v20.172C29.768 55.953 28.89 56 28 56c-7.57 0-14.353-3.364-18.937-8.679l11.13-26.32 10.44 14.69z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.304 34.796l-8.286 16.932A25.176 25.176 0 017.64 45.51L20.192 21l1.805 2.539.307 11.256z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.296 21a5.957 5.957 0 1011.913 0H9.296z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.048 25.852a1.078 1.078 0 110-2.156 1.078 1.078 0 010 2.156zM48.168 25.852a1.078 1.078 0 110-2.156 1.078 1.078 0 010 2.156z",
    fill: "#DC66C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.527 39.777a9.056 9.056 0 01-10.336-8.966v-9.81h2.555v9.81c0 4.569 3.384 8.347 7.781 8.966z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.273 24.957a4.233 4.233 0 100-8.466 4.233 4.233 0 000 8.466z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.383 23.193a2.47 2.47 0 100-4.938 2.47 2.47 0 000 4.938z",
    fill: "#453D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.273 27.167c2.282 0 4.132-1.001 4.132-2.236 0-1.235-1.85-2.236-4.132-2.236-2.282 0-4.131 1.001-4.131 2.236 0 1.235 1.85 2.236 4.131 2.236z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.585 30.11a3.053 3.053 0 100-6.106 3.053 3.053 0 000 6.105z",
    fill: "#DA387D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.654 21.082a1.38 1.38 0 100-2.761 1.38 1.38 0 000 2.761zM26.154 22.25a.796.796 0 100-1.59.796.796 0 000 1.59z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.777 30.57v4.853a4.546 4.546 0 01-4.546 4.547c-2.511 0-4.547-3.495-4.547-6.006v-2.147l.933-.665c0-.511.415-.926.927-.926l5.13-.583h1.176c.512 0 .927.415.927.926z",
    fill: "#453D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.675 29.643v1.248a.927.927 0 01-.927.926h-6.063V30.57c0-.511.414-.926.926-.926h6.064z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.57 38.353v4.906c-2.01 2.902-4.618 7.314-7.647 9.146a24.9 24.9 0 01-2.238 1.202V33.964h5.496a4.389 4.389 0 014.388 4.389z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.497 38.353v5.416a25.01 25.01 0 01-2.144 3.056c-.168.206-.393-.353-.568-.154l-.638-7.64c0-2.424-.758-5.067-3.182-5.067h2.143a4.389 4.389 0 014.389 4.389z",
    fill: "#D379FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.353 38.353v8.472a24.94 24.94 0 01-2.143 2.306c-.085.08-.489-.54-.575-.46l-.237-9.507c0-2.424-1.153-5.2-3.577-5.2h2.144a4.389 4.389 0 014.388 4.389z",
    fill: "#FDC869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.21 38.353V49.13a24.678 24.678 0 01-2.144 1.82c-.053.04-.745-.558-.799-.518L42.32 39.1c0-2.424-1.219-5.135-3.642-5.135h2.143a4.388 4.388 0 014.389 4.389z",
    fill: "#96FD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.066 38.353V50.95a24.573 24.573 0 01-2.143 1.454V38.353a4.389 4.389 0 00-2.238-3.828v-.561a4.388 4.388 0 014.381 4.389z",
    fill: "#69C0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rainbow_svg__clip0_2637_47780"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/rainbow.7d3e069444a10b21f97047f524836894.svg";
export { SvgRainbow as ReactComponent };